import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import moment from "moment";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid2,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { Input } from "./Input";

import Loading from "./Loading";

import { studentDueDate } from "../services/students";

const StudentChangeDueDate = ({
  open,
  onClose,
  data,
  onAction,
}: {
  open: boolean;
  onClose: () => void;
  data: any;
  onAction: () => void;
}) => {
  const today = moment().startOf("day");
  const [dueDate, setDueDate] = useState("");
  const plan = data?.studentOnPlan[0] || null;

  const { mutate, isPending } = useMutation({
    mutationFn: studentDueDate,
    onSuccess: () => {
      onAction();
      toast.success("Data atualizada para o aluno");
      onClose();
    },

    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(
        String(e?.response?.data?.message) ||
          "Não conseguimos atualizar a data do aluno"
      );
    },
  });

  const isChangeDate = !moment(plan?.endDate).isSame(dueDate, "day");

  useEffect(() => {
    if (plan?.endDate) {
      setDueDate(moment(plan?.endDate).format("YYYY-MM-DD"));
    }
  }, [plan]);

  return (
    <Dialog maxWidth="sm" open={open} onClose={() => onClose()}>
      <Loading loading={isPending} />
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={1}>
          <Grid2 size={{ xs: 10, md: 11 }}>
            <Typography variant="h2" fontSize={20} fontWeight={600}>
              Alterar data de vencimento
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 2, md: 1 }}>
            <IconButton onClick={() => onClose()}>
              <IconX style={styles.iconStyle} />
            </IconButton>
          </Grid2>

          <Grid2 size={12}>
            <Typography>
              Escolha a data para proxima renovação do plano e pagamento.
            </Typography>
            <Typography>
              Renovação: {moment(plan?.endDate).format("DD/MM/YYYY")}
            </Typography>
            {isChangeDate && (
              <Typography>
                Nova renovação: {moment(dueDate).format("DD/MM/YYYY")}
              </Typography>
            )}
          </Grid2>

          <Grid2 size={12} sx={{ mt: 2 }}>
            <Input
              id="dueDate"
              name="dueDate"
              label="Vencimento do plano"
              type="date"
              fullWidth
              value={dueDate}
              onChange={(e) => {
                setDueDate(e?.target?.value);
              }}
              onFocus={(e: React.FocusEvent<HTMLInputElement>) =>
                e.target.showPicker()
              }
            />
          </Grid2>
        </Grid2>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: "secondary.main" }}>
        <Stack flexDirection={"row"} gap={1}>
          <Button
            variant="contained"
            disabled={!isChangeDate}
            onClick={() => {
              if (moment(dueDate).isBefore(plan?.startDate, "day")) {
                toast.error(
                  "A nova data não pode ser anterior ao início do plano."
                );
                return;
              }

              if (moment(dueDate).isBefore(today)) {
                toast.error(
                  "A nova data não pode ser anterior ao dia de hoje."
                );
                return;
              }

              mutate({
                id: data.id,
                studentOnPlanId: plan?.id,
                dueDate: moment(dueDate).toDate(),
              });
            }}
          >
            Salvar
          </Button>{" "}
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

const styles = {
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
    backgroundColor: "secondary.dark",
  },
  iconStyle: {
    color: "primary.main",
  },
};

export default StudentChangeDueDate;
